import { createContext } from 'react';
import type { TrackingService } from '../../types/feature-service-types';
export type TrackingServiceContextState = {
  trackingService: TrackingService;
};

export const TrackingServiceContext = createContext<Partial<TrackingServiceContextState>>({});
